// eslint-disable-next-line import/no-extraneous-dependencies
import { LicenseInfo } from '@mui/x-license-pro';
LicenseInfo.setLicenseKey('3f8ead05033a8551cc79b680a6606a40Tz03MjQ0MixFPTE3MjMyMTQ3OTMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');